export default "__VITE_ASSET__DROCnFiC__"